var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section", attrs: { id: "informations" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "section-body" }, [
      _c("textarea", {
        attrs: {
          placeholder:
            "Escreva instruções e cuidados para a limpeza, ou qualquer informação que achar necessária...",
          name: "description",
          rows: "5"
        },
        domProps: { value: _vm.additional_informations },
        on: {
          input: function($event) {
            return _vm.setAdditionalInformations($event.target.value)
          }
        }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("\n    INFORMAÇÕES SOBRE A LIMPEZA\n    "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41f223f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f223f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/AdditionalInformations.vue
// module id = null
// module chunks = 